var _path, _path2, _path3, _circle, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnifierIconMographical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 189,
    viewBox: "0 0 153 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1028 47.8921L18.1445 47.7978L18.166 47.697C20.2735 37.8376 27.4302 29.4551 36.627 23.0859C45.8144 16.7231 56.9261 12.4509 66.7165 10.7712C97.6713 5.46018 127.071 26.2486 132.382 57.2035C133.937 66.268 134.449 75.5199 131.894 84.8907C129.344 94.2472 123.711 103.808 112.837 113.447C106.533 119.034 100.378 120.724 94.5722 121.214C91.9199 121.437 89.3482 121.411 86.8326 121.384C86.572 121.382 86.3119 121.379 86.0524 121.377C83.3699 121.352 80.7367 121.357 78.252 121.735C70.3107 120.453 58.713 115.871 48.4223 107.742C38.0787 99.5705 29.1248 87.8723 26.4747 72.4262C25.5901 67.2703 23.0436 63.6228 20.8792 60.5226C20.488 59.9623 20.1093 59.4198 19.7551 58.8895C18.5793 57.1291 17.6799 55.5264 17.3076 53.8036C16.9429 52.1163 17.0684 50.2333 18.1028 47.8921Z",
    fill: "url(#paint0_linear_7_110)",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.449 155.923L126.735 163.351L85.8185 126.487L108.584 116.471L131.449 155.923Z",
    fill: "#F5F5F5",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3682 125.298L101.482 115.4L128.239 164.362L110.125 174.261L83.3682 125.298Z",
    fill: "#212121"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68.2542,
    cy: 71.6452,
    r: 57.8677,
    transform: "rotate(-9.73555 68.2542 71.6452)",
    fill: "#212121"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.2542,
    cy: 71.6451,
    r: 43.2615,
    transform: "rotate(-9.73555 68.2542 71.6451)",
    fill: "#F5F5F5",
    stroke: "#3A3A3A",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_110",
    x1: 87.1177,
    y1: 63.916,
    x2: 126.024,
    y2: 12.0992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C957FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifierIconMographical);
export default __webpack_public_path__ + "static/media/Magnifier Icon Mographical.50ded5b7d3900aa39dd89dbd8e5aaed9.svg";
export { ForwardRef as ReactComponent };